import React from 'react';
import { Box, Typography } from '@mui/material';
import { BasicButton } from '../Base/BasicButton';

const PendingMessage = ({ msg, onCancel }) => {
    return (
        <>
            <Typography variant="h1">
                {msg}
            </Typography>
            <Box
                sx={{
                    mt: 2,
                    px: 1,
                    justifyContent: 'space-between',
                    display: 'flex',
                }}
            >
                <BasicButton
                    text="Cancel"
                    icon="/assets/cancelSvg.svg"
                    textColor="#707070"
                    bg="white"
                    borderColor="#707070"
                    variant="outlined"
                    onClick={onCancel && onCancel}
                />
            </Box>
        </>
    );
};

export default PendingMessage;
